import React from 'react';
import { Button } from '../ui/button';

const FundingReportExportButton = ({ onExport, exporting, label = 'Export CSV' }) => (
  <Button
    variant="outline"
    className="rounded-xl"
    onClick={onExport}
    disabled={exporting}
  >
    {exporting ? 'Exporting...' : label}
  </Button>
);

export default FundingReportExportButton;
